import React, { FC, useEffect, useState } from "react";
import moment from "moment";
import axios from "axios";
import { handleError } from "../error/ErrorHandler";
import { useTypedSelector } from "../reducers";

interface Props {
  data: any;
}

interface SelectProps {
  value?: string;
  label?: string;
}

interface FileInfo {
  fileNm: string;
  sysFileNm: string;
  fileDir: string;
}

const ShineCatalogContent: FC<Props> = ({ data }) => {
  const uploadUrl = '/api/catalog/download';
  const { isLogin } = useTypedSelector(state => state.auth);
  const [allFiles, setAllFiles] = useState([]);

  const getAllFiles = async (fileId: any) => {
    try {
        const res = await axios.get(`/api/file/all?fileIdList=${fileId}`);
        setAllFiles(res.data);
    } catch(err) {
        handleError(err);
    }
  };

  const downloadFile = async (fileId: string) => {
    try {
      if (data.fileAuth !== 'A' && !isLogin) {
        alert('로그인 하셔야 이용가능합니다.');
        return;
      }
      const res = await axios(`${uploadUrl}/${fileId}`, { responseType: 'blob' });
      const blob = new Blob([res.data, { type: 'application/octet-stream; UTF-8' }]);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = decodeURIComponent(escape(res.headers['content-origin-file-name']));
      document.body.appendChild(a);
      a.click();
    } catch (err) {
      console.error(err);
      alert('에러가 발생했습니다.'); 
    }
  }

  const columns = [
    { label: '데이터 명', value: 'catalogDescSml', type: 'string' },
    { label: '등록일', value: 'loadDtm', type: 'date' },
    { label: '최종 수정일', value: 'updtDtm', type: 'date' },
    { label: '데이터 설명', value: 'catalogDescLrg', type: 'string' },
    { label: '제공 기관', value: 'cstmNm', type: 'string' },
    { label: '공개 범위', value: 'authNm', type: 'string' },
    // { label: '첨부 파일', value: 'fileNm', type: 'string' },
  ]
  useEffect(() => {
    getAllFiles(data.fileId);
  }, [ data ]);

  return (
    <>
      <div className="catalog-content-wrapper">
        { columns.map( (column, idx) => {
          return (
            <div key={idx} className="catalog-content">
              <div className="catalog-content-label">{column.label}</div>

              <div className="catalog-content-value">
                {column.type === 'date' ? moment(data[column.value]).format('YYYY-MM-DD HH:mm:ss') : data[column.value]}
              </div>
            </div>
          )
        })}
        {allFiles?.length > 0 && 
          <div className={'catalog-content'}>
            <div className="catalog-content-label">파일 목록</div>
            <div className="catalog-content-value">
            { allFiles.map( (file: any, idx: number) => {
              return (
                <div key={idx} className="pointer file-download" onClick={() => downloadFile(file.fileId)}>{file.fileNm}</div>
              )
            })}
            </div>
          </div>
        }
      </div>
    </>
  );
}

export default ShineCatalogContent;
